import { Box } from '@chakra-ui/react';
import * as React from 'react';

export const CreateAnswerModalFooter: React.FC = (props) => {
  return (
    <Box
      bg="gray.50"
      borderBottomRadius="md"
      borderTop="1px"
      borderColor="gray.100"
      px="6"
      py="4"
    >
      {props.children}
    </Box>
  );
};
